import store from './store'
import TicketSaleSelectors from '../ducks/ticket-sale/ticket-sale.selectors'
import BusSeatSelectionSelectors from '../selectors/bus-seat-selection.selectors'
import { isSameSeat, seatKeyOf } from './seat-key.helper'

const getState = (store) => ({
	groupGoing: store.ticketSale.groupGoing,
	groupReturn: store.ticketSale.groupReturn,
	serviceGoing: store.ticketSale.serviceGoing,
	serviceReturn: store.ticketSale.serviceReturn,
	originIbgeCode: store.ticketSale.originIbgeCode,
	busSeatsGoing: store.busSeatSelection.busSeatsGoing,
	poltronasIda: store.busSeatSelection.poltronasIda,
	originLocalityId: store.ticketSale.originLocalityId,
	raceDateGoing: store.ticketSale.raceDateGoing,
	raceDateReturn: store.ticketSale.raceDateReturn,
	destinationIbgeCode: store.ticketSale.destinationIbgeCode,
	destinationLocalityId: store.ticketSale.destinationLocalityId,
	tripGoing: TicketSaleSelectors.getTripGoing(store),
	tripReturn: TicketSaleSelectors.getTripReturn(store),
	isBusSelectionGoingStep: TicketSaleSelectors.isBusSelectionGoingStep(store),
	ordemViagemIda: TicketSaleSelectors.getOrdemViagemIda(store),
	selectedBusSeatsGoing: BusSeatSelectionSelectors.getSelectedBusSeatsGoing(
		store.busSeatSelection
	),
	selectedBusSeatsReturn: BusSeatSelectionSelectors.getSelectedBusSeatsReturn(
		store.busSeatSelection
	),
	conexao: store.conexao,
	selectedPoltonasIda: BusSeatSelectionSelectors.getSelectedViagemIda(
		store.busSeatSelection
	),
})

// Spec 055: aceita a poltrona inteira (andar + numero) ou so o numero (compatibilidade). A reserva e
// achada pela chave da poltrona — pelo numero puro, a "01" de um andar devolvia a reserva do outro.
function seatArgs(seat) {
	const isObject = seat !== null && typeof seat === 'object'
	const number = isObject ? seat.number || seat.seatNumber || seat.busSeat : seat
	const key = isObject ? seatKeyOf(seat) || number : seat

	return { number, key, seatId: isObject ? seat.seatId : undefined }
}

function getDeselectParams(seatOrNumber) {
	const { number: busSeat, key: seatKey, seatId } = seatArgs(seatOrNumber)

	const {
		tripGoing,
		groupGoing,
		serviceGoing,
		selectedBusSeatsGoing,
		isBusSelectionGoingStep,
		selectedPoltonasIda,
		conexao,
	} = getState(store.getState())

	if (conexao != null && conexao.ehConexaoIda && isBusSelectionGoingStep) {
		const { transactionId, bookingCode, provider, originId, destinationId } =
			selectedPoltonasIda.find((seat) => isSameSeat(seat, seatKey))

		const conexaoTrechoAtual =
			conexao.conexaoIda.trecho[parseInt(conexao.ordemViagemIda) - 1]

		return {
			busSeat,
			seatId,
			bookingCode,
			transactionId,
			group: conexaoTrechoAtual.group,
			service: conexaoTrechoAtual.service,
			tripDate: conexaoTrechoAtual.departure,
			classCode: conexaoTrechoAtual.classCode,
			busCompany: conexaoTrechoAtual.enterprise,
			scheduleKey: conexaoTrechoAtual.scheduleKey,
			raceDate: conexaoTrechoAtual.raceDate,
			provider,
			originId,
			destinationId,
		}
	} else {
		if (isBusSelectionGoingStep) {
			const {
				transactionId,
				bookingCode,
				originId,
				provider,
				destinationId,
			} = selectedBusSeatsGoing.find((seat) => isSameSeat(seat, seatKey))
			return {
				transactionId,
				bookingCode,
				busSeat,
				seatId,
				originId,
				group: groupGoing,
				destinationId,
				service: serviceGoing,
				tripDate: tripGoing.departure,
				classCode: tripGoing.classCode,
				busCompany: tripGoing.enterprise,
				scheduleKey: tripGoing.scheduleKey,
				raceDate: tripGoing.raceDate,
				provider,
			}
		} else {
			return getDeselectParamsReturn(seatOrNumber)
		}
	}
}

function getDeselectParamsReturn(seatOrNumber) {
	const { number: busSeat, key: seatKey, seatId } = seatArgs(seatOrNumber)

	const { tripReturn, groupReturn, serviceReturn, selectedBusSeatsReturn } =
		getState(store.getState())

	const { transactionId, bookingCode, provider, originId, destinationId } =
		selectedBusSeatsReturn.find((seat) => isSameSeat(seat, seatKey))
	return {
		busSeat,
		seatId,
		bookingCode,
		transactionId,
		group: groupReturn,
		service: serviceReturn,
		tripDate: tripReturn.departure,
		classCode: tripReturn.classCode,
		busCompany: tripReturn.enterprise,
		scheduleKey: tripReturn.scheduleKey,
		raceDate: tripReturn.raceDate,
		provider,
		originId,
		destinationId,
	}
}

const busSeatSelectionHelper = { getDeselectParams, getDeselectParamsReturn }

export default busSeatSelectionHelper
